import { Component, OnInit } from '@angular/core';
import { DocumentManagementService } from './document-management.service';

@Component({
	selector: 'app-documents',
	templateUrl: './documents.component.html',
	styleUrls: [],
})
export class DocumentsComponent implements OnInit {
	files: any[] = [];
	loading: boolean = true;
	sortOption: string = 'sortPosition'; // Default sort
	downloadingFile: string | null = null;
	resourcesCategoryId: number | null = null;
	constructor(private documentService: DocumentManagementService) {}

	ngOnInit(): void {
		this.loadDocuments();
	}

	loadDocuments(): void {
		this.loading = true;
		//fetch all categories
		this.documentService.fetchCategories().subscribe({
			next: (data: any) => {
				//find the category with the name "Resources"
				const resourcesCategory = data.categories.find((category: any) => category.name === 'Resources');
				if (resourcesCategory) {
					this.resourcesCategoryId = resourcesCategory.id;
					this.documentService.getFilesByCategory(this.resourcesCategoryId).subscribe({
						next: (data: any) => {
							this.files = data.files;
							this.sortFiles();
							this.loading = false;
						},
						error: (error) => {
							console.error('Error loading documents:', error);
							this.loading = false;
						},
					});
				} else {
					console.error('Resources category not found');
					this.loading = false;
				}
			},
		});
	}

	sortFiles(): void {
		switch (this.sortOption) {
			case 'sortPosition':
				this.files.sort((a, b) => a.filename.localeCompare(b.sortPosition));
				break;
			case 'alphabetical':
				this.files.sort((a, b) => a.filename.localeCompare(b.filename));
				break;
			case 'newest':
				this.files.sort(
					(a, b) => new Date(b.updated || b.created).getTime() - new Date(a.updated || a.created).getTime()
				);
				break;
			case 'oldest':
				this.files.sort(
					(a, b) => new Date(a.updated || a.created).getTime() - new Date(b.updated || b.created).getTime()
				);
				break;
		}
	}

	openFile(file: any): void {
		this.documentService.getFileUrl(file.id).subscribe({
			next: (response: any) => {
				this.downloadingFile = null;
				if (response && response.url) {
					window.open(response.url, '_blank');
				} else {
					console.error('Invalid response format:', response);
					//	this.showErrorMessage('Failed to download file: Invalid response');
				}
			},
			error: (error) => {
				console.error('Error opening file:', error);
			},
		});
	}

	downloadAllFiles(): void {
		this.downloadingFile = 'all files';
		this.documentService.downloadAllFilesByCategory(this.resourcesCategoryId).subscribe({
			next: (response: Blob) => {
				console.log('Downloading all files:', response);
				const url = window.URL.createObjectURL(response);
				const a = document.createElement('a');
				a.href = url;
				a.download = 'documents.zip'; // Suggested filename
				document.body.appendChild(a);
				a.click();

				// Clean up
				window.URL.revokeObjectURL(url);
				document.body.removeChild(a);
				this.downloadingFile = null;
			},
			error: (error) => {
				console.error('Error downloading files:', error);
				this.downloadingFile = null;
			},
		});
	}
}
